import { useRef, useEffect } from "react"

export const useClickOutside = (handleClickOutside) => {
  let containerNode = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let onClickOutsideFunction = (event) => {
      if (!containerNode.current.contains(event.target)) {
        handleClickOutside()
      }
    }

    document.addEventListener("mousedown", onClickOutsideFunction)

    return () => {
      document.removeEventListener("mousedown", onClickOutsideFunction)
    }
  })

  return containerNode
}
